import { type CellContext } from '@tanstack/react-table';
import dayjs from 'dayjs';

export function CellDatetime<TData, TValue>({ getValue }: CellContext<TData, TValue>) {
    const value = getValue();
    if (!value) return '-';

    const dateFormat = import.meta.env.VITE_DATE_FORMAT || 'DD.MM.YYYY';
    const timeFormat = import.meta.env.VITE_TIME_FORMAT || 'HH:mm:ss';

    const datetime = new Date(value.toString());
    const formattedDate = datetime ? dayjs(datetime).format(dateFormat) : '-';
    const formattedTime = datetime ? dayjs(datetime).format(timeFormat) : '';

    return (
        <div className="flex flex-col gap-0 whitespace-nowrap">
            <span>{formattedTime}</span>
            <span className="-mt-px whitespace-nowrap text-gray-500">{formattedDate}</span>
        </div>
    );
}
